import { render, staticRenderFns } from "./BalanceChart.vue?vue&type=template&id=e8c23ab2"
import script from "./BalanceChart.vue?vue&type=script&lang=js"
export * from "./BalanceChart.vue?vue&type=script&lang=js"
import style0 from "./BalanceChart.vue?vue&type=style&index=0&id=e8c23ab2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports